import { DefaultDetailContext } from 'src/app/controls/forms/default-detail-context';
import { IAttribute } from 'src/app/models/interfaces/attribute.interface';

export class AttributeDetailContext extends DefaultDetailContext<IAttribute, number> {}
